// extracted by mini-css-extract-plugin
module.exports = {"storyBeatFooter":"Footer_storyBeatFooter__o5R0c"};